import get_router from "./router"
import urls, { DEFAULT_VIEW } from "./urls"

export default (name = DEFAULT_VIEW, params = {}) => {
  console.info(`Navigating to ${name} with params:`, params)
  get_router().push(
    (urls[name] as { navigate: (p: object) => unknown }).navigate(params)
  )
}
